import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=0b7e4e76&scoped=true&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "./Result.vue?vue&type=style&index=0&id=0b7e4e76&scoped=true&lang=css&"
import style1 from "./Result.vue?vue&type=style&index=1&id=0b7e4e76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7e4e76",
  null
  
)

export default component.exports